import { UserStore } from "../store/useUser";

export const getToken = () => {
    return UserStore.jwt?.access_token;
};

export const getRefreshToken = () => {
    return UserStore.jwt?.refresh_token;
}

export const parseToken = (token: string) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};
